import React from "react"
import { storyblokEditable } from "@storyblok/react"

import Markdown from "react-markdown"

import { GuteSiegelProducteSearch } from "gatsby-theme-gba"

const GuteSiegelProducteSearchEditable = ({ blok }) => {
  let csvData = blok.csv.text
  function csvJSON(csv) {
    let lines = csv.split("\n")
    let result = []
    let headers = [
      "Produkte",
      "Artikelnummer",
      "Charge",
      "Schwermetalle",
      "Mikrobiologie",
      "Pestizide",
      "Beurteilung",
      "Zertifikat",
      "Charge-2",
      "Schwermetalle-2",
      "Mikrobiologie-2",
      "Pestizide-2",
      "Beurteilung-2",
      "Zertifikat-2",
      "Charge-3",
      "Schwermetalle-3",
      "Mikrobiologie-3",
      "Pestizide-3",
      "Beurteilung-3",
      "Zertifikat-3",
      "Charge-4",
      "Schwermetalle-4",
      "Mikrobiologie-4",
      "Pestizide-4",
      "Beurteilung-4",
      "Zertifikat-4",
      "Charge-5",
      "Schwermetalle-5",
      "Mikrobiologie-5	",
      "Pestizide-5	",
      "Beurteilung-5 ",
      "Zertifikat-5",
      "Charge-6",
      "Schwermetalle-6	",
      "Mikrobiologie-6	",
      "Pestizide-6	",
      "Beurteilung-6	",
      "Zertifikat-6",
      "Charge-7",
      "Schwermetalle-7",
      "Mikrobiologie-7",
      "Pestizide-7",
      "Beurteilung-7",
      "Zertifikat-7",
      "Charge-8",
      "Schwermetalle-8",
      "Mikrobiologie -8	",
      "Pestizide-8	",
      "Beurteilung-8 ",
      "Zertifikat-8",
      "Charge-9",
      "Schwermetalle-9	",
      "Mikrobiologie -9	",
      "Pestizide-9	",
      "Beurteilung-9	",
      "Zertifikat-9",
    ]
    for (let i = 1; i < lines.length - 1; i++) {
      let obj = {}
      let currentline = lines[i].split(";")
      for (let j = 0; j < headers.length + 2; j++) {
        obj[headers[j]] = currentline[j]
        if (j === headers.length + 1) {
          obj["name"] = currentline[0].replace(/-/g, " ").replace(/®/g, "")
          obj["nameHypen"] = currentline[0].replace(/®/g, "")
        }
      }
      result.push(obj)
    }
    return result
  }
  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <GuteSiegelProducteSearch
        data={csvJSON(csvData)}
        popupText1={blok.popupText1}
        popupText2={blok.popupText2}
        popupText3={blok.popupText3}
        popupText4={blok.popupText4}
        popupText5={blok.popupText5}
        explanatory={blok.explanatory}
        productPerPage={blok.productPerPage ? blok.productPerPage : 20}
        searchInfo={blok.searchInfo}
        searchTableText={blok.searchTableText}
        tableHeaderArticleNo={blok.tableHeaderArticleNo}
        tableHeaderCertificate={blok.tableHeaderCertificate}
        tableHeaderCharge={blok.tableHeaderCharge}
        tableHeaderHeavymetal={blok.tableHeaderHeavymetal}
        tableHeaderMicroOrganism={blok.tableHeaderMicroOrganism}
        tableHeaderPesticides={blok.tableHeaderPesticides}
        tableHeaderProduct={blok.tableHeaderProduct}
        tableHeaderRemark={blok.tableHeaderRemark}
        viewInfo={blok.viewInfo}
        updateDateText={blok.updateDateText}
        updateDate={blok.updateDate}
        moreChargesBtnText={blok.moreChargesBtnText}
        lessChargesBtnText={blok.lessChargesBtnText}
        notRelevantText={blok.notRelevantText}
      >
        <Markdown>{blok.introText}</Markdown>
      </GuteSiegelProducteSearch>
    </div>
  )
}
export default GuteSiegelProducteSearchEditable
